// Regex rules
export const nameRegex = /^[A-Za-z\s]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*.()])(?=.{8,})/;

// Validation functions
export const isValidNameCheck = (value) => nameRegex.test(value);
export const isValidEmailCheck = (value) => emailRegex.test(value);
export const isValidPasswordCheck = (value) => passwordRegex.test(value);

// Helper validation functions
export const isValidNameLength = (value, minLength = 3) => value.trim().length >= minLength;
export const isValidPasswordLength = (value, minLength = 8) => value.trim().length >= minLength;
export const doPasswordsMatch = (password, confirmPassword) => password.trim() === confirmPassword.trim();

// Document title validation helpers
export const isValidTitleLength = (value, minLength = 3, maxLength = 75) => {
	const trimmed = value.trim();
	return trimmed.length >= minLength && trimmed.length <= maxLength;
};
export const isValidDocumentTitle = (value) => {
	const trimmed = value.trim();
	return trimmed.length > 0 && isValidTitleLength(trimmed);
};
